import script from "./StubBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./StubBlock.vue?vue&type=script&setup=true&lang=js"

import "./StubBlock.vue?vue&type=style&index=0&id=10b68476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b68476"]])

export default __exports__